export enum SessionRoutes {
  ROOT = '',
  NEW = 'new',
  QUICK_SETUP = 'quick-setup',
  ACTIVE = 'active',
  DRILL_COMPLETED = 'drill-completed',
  ADD_DRILL = 'add-drill',
  SUMMARY = 'summary'
}
